import React from 'react';
import { facilityShortLabel } from 'utils/campusLabels';

interface FacilityBadgeProps {
  facility: { name?: string; configuration?: unknown } | null | undefined;
  /** Render nothing unless the campus has more than one facility. */
  show?: boolean;
  className?: string;
}

/** Small facility tag for cards and rows in campus-wide views. */
const FacilityBadge: React.FC<FacilityBadgeProps> = ({
  facility,
  show = true,
  className = ''
}) => {
  const label = facilityShortLabel(facility);
  if (!show || !label) return null;

  return (
    <span
      className={`inline-block max-w-full truncate rounded bg-indigo-50 border border-indigo-200 px-1.5 py-0.5 text-[10px] font-medium leading-tight text-indigo-700 ${className}`}
      title={facility?.name || label}
    >
      {label}
    </span>
  );
};

export default FacilityBadge;
